import React, { useState, useEffect } from "react"
import axios from "axios"
import { Container, Row, Col, Table, Spinner, Button } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toast } from "react-toastify"
import EditSubscriptionModal from "components/Modal/EditSubscriptionModal"
import DeleteModal from "components/Common/DeleteModal"
import { Switch } from "@mui/material"

const SubscriptionList = () => {
  document.title = "Subscription List"

  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [editModal, setEditModal] = useState(false)
  const [sports, setSports] = useState([])
  const [clubs, setClubs] = useState([])
  const [selectedSubscription, setSelectedSubscription] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showClub, setShowClub] = useState(false)
  const fetchSubscriptions = async () => {
    try {
      const queryParam = showClub ? "club" : "sport"
      const response = await axios.get(
        `${process.env.REACT_APP_DATABASEURL}/subscription/get-type-admin?type=${queryParam}`,
        {
          headers: {
            token: localStorage.getItem("authUser")?.replace(/"/g, ""),
          },
        }
      )
      setSubscriptions(response.data)
    } catch (error) {
      toast.error("Failed to load subscriptions.")
    } finally {
      setLoading(false)
    }
  }

  const fetchSports = async () => {
    try {
      await axios
        .get(`${process.env.REACT_APP_DATABASEURL}/sports/find`)
        .then(response => {
          setSports(response.data)
        })
    } catch (error) {
      console.error("Error fetching sports:", error)
      toast.error("Failed to load sports")
    }
  }

  const fetchClubs = async () => {
    try {
      await axios
        .get(`${process.env.REACT_APP_DATABASEURL}/clubs/find`)
        .then(response => {
          setClubs(response.data)
        })
    } catch (error) {
      console.error("Error fetching clubs:", error)
      toast.error("Failed to load clubs")
    }
  }

  useEffect(() => {
    fetchSubscriptions()
    fetchSports()
    fetchClubs()
  }, [])

  const toggleEditModal = () => setEditModal(!editModal)

  const handleEdit = subscription => {
    setSelectedSubscription(subscription)
    toggleEditModal()
  }

  const handleSaveFinished = () => {
    toggleEditModal()
    fetchSubscriptions()
  }

  const handleVisibilityChange = async subscription => {
    const token = localStorage.getItem("authUser")?.replace(/"/g, "")
    try {
      await axios.put(
        `${process.env.REACT_APP_DATABASEURL}/subscription/update/${subscription.id}`,
        {
          visibility: !subscription.visibility,
        },
        {
          headers: { token },
        }
      )
      fetchSubscriptions()
      toast.success("Subscription updated successfully")
    } catch (error) {
      toast.error("Failed to update subscription. Please try again.")
    }
  }

  const handleDelete = async id => {
    const token = localStorage.getItem("authUser")?.replace(/"/g, "")
    try {
      await axios.put(
        `${process.env.REACT_APP_DATABASEURL}/subscription/update/${id}`,
        {
          visibility: false,
        },
        {
          headers: { token },
        }
      )
      fetchSubscriptions()
      toast.success("Subscription deleted successfully")
    } catch (error) {
      toast.error("Failed to delete subscription. Please try again.")
    }
  }
  useEffect(() => {
    fetchSubscriptions()
  }, [showClub])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Subscriptions"
            breadcrumbItem="Subscription List"
          />
          <Row>
            <Col lg={12}>
              {loading ? (
                <div className="text-center mt-5">
                  <Spinner color="primary" />
                </div>
              ) : (
                <div>
                  <div className="d-flex justify-content-end align-items-center">
                    <Switch
                      checked={showClub}
                      onChange={() => setShowClub(!showClub)}
                    />
                    {showClub ? "Show Club" : "Show Sport"}
                  </div>

                  <Table bordered className="mt-2">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th>{showClub ? "Club" : "Sport"}</th>
                        <th>Visibility</th>
                        <th>Duration</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subscriptions.length > 0 ? (
                        subscriptions.map((subscription, index) => (
                          <tr key={subscription.id}>
                            <td>{index + 1}</td>
                            <td>{subscription.title}</td>
                            <td
                              className="text-truncate"
                              style={{ maxWidth: 400 }}
                            >
                              {subscription.description}
                            </td>
                            <td>{subscription.price} TND</td>

                            {showClub ? (
                              <td>{subscription.club?.name || "N/A"}</td>
                            ) : (
                              <td>{subscription.sport?.name || "N/A"}</td>
                            )}
                            <td>
                              <Switch
                                checked={subscription.visibility}
                                onChange={() =>
                                  handleVisibilityChange(subscription)
                                }
                              />
                              {subscription.visibility ? "Visible" : "Hidden"}
                            </td>

                            <td>{subscription.duration} Months</td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                className="me-2"
                                onClick={() => handleEdit(subscription)}
                              >
                                Edit
                              </Button>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  setSelectedSubscription(subscription)
                                  setShowDeleteModal(true)
                                }}
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No subscriptions found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Col>
          </Row>
        </Container>

        {selectedSubscription && (
          <EditSubscriptionModal
            show={editModal}
            toggle={toggleEditModal}
            subscription={selectedSubscription}
            onCloseClick={toggleEditModal}
            clubs={clubs}
            sports={sports}
            onSaveFinished={handleSaveFinished}
          />
        )}
        <DeleteModal
          show={showDeleteModal}
          onCloseClick={() => setShowDeleteModal(false)}
          onDeleteClick={() => {
            handleDelete(selectedSubscription.id)
            setShowDeleteModal(false)
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default SubscriptionList
